import { render, staticRenderFns } from "./Matchmaking.vue?vue&type=template&id=00d27008&scoped=true&"
import script from "./Matchmaking.vue?vue&type=script&lang=js&"
export * from "./Matchmaking.vue?vue&type=script&lang=js&"
import style0 from "./Matchmaking.vue?vue&type=style&index=0&id=00d27008&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d27008",
  null
  
)

export default component.exports